/* eslint-disable react/jsx-indent */
import React, { useState, useCallback, useEffect } from 'react'
import { Formik, Form } from 'formik'
import { useModal } from 'react-modal-hook'
import { useSelector } from 'react-redux'
import Loading from 'custom/assets/loaders/Loading'
import RequestService from '../../../../services/requests.service'
import Modal from '../../../../components/Modal/Modal'
import { accountsSelector, carouselCurrentItemSelector, getFeatureListSelector } from '../../../../selectors'
import { BlockDebitCardSchema } from '../../../../schemas/requests'
import InputError from '../../../../components/InputError/InputError'
import NeoButton from '../../../../components/NeoButton/NeoButton'
import NeoInput from '../../../../components/NeoInput/NeoInput'
import NeoSuccess from '../../../../components/FormComponents/NeoSuccess'
import NeoOTP from '../../../../components/FormComponents/NeoOTP'
import { useHistory } from 'react-router-dom'
import NeoLoader from '../../../../components/FormComponents/NeoLoader'
import LayoutWithAccountCard from '../../../../layout/Layout/layout-account-card'
import { ACCOUNT_SUB_MENUS, REQUEST_MENUS } from '../../../../layout/Layout/menu-names'
import AccountDisplay from '../../../../components/account-display/account-display'
import { VALIDATION_MESSAGES } from '../../../../utils/translation-constants'
import { useTranslation } from 'react-i18next'

const parentMenus = REQUEST_MENUS.filter((ele) => ele.key !== 'DEBIT_CARD')
const menuDetails = REQUEST_MENUS.filter((ele) => ele.key === 'DEBIT_CARD')[0]
const parentMenuDetails = ACCOUNT_SUB_MENUS.filter((ele) => ele.key === 'REQUESTS')[0]

function BlockDebitCard() {
  const { t } = useTranslation()
  const [stage, setStage] = useState(1)
  const [loading, setLoading] = useState(false)
  const [loadingCards, setLoadingCards] = useState(false)
  const [message, setMessage] = useState('')
  const [cards, setCards] = useState([])
  const [formValues, setFormValues] = useState(null)
  const history = useHistory()
  const [otp, setOtp] = useState('')
  const [otpEnabled, setOtpEnabled] = useState(false)
  const currentAccountDetail = useSelector(carouselCurrentItemSelector)
  const featureList = useSelector(getFeatureListSelector)
  const featureDetails = featureList['BLOCK_CARD']
  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <div className='modal-error-body'>
          <h6>
            <b>{message?.code}</b> : {message?.message}
          </h6>
          <div className='modal-btn-style'>
            <NeoButton
              mode='newDesign'
              type='button'
              text={'OK'}
              onClick={() => {
                hideModal()
                history.push('/requests')
              }}
            />
          </div>
        </div>
      </Modal>
    ),
    [message],
  )

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm()
      case 2:
        return renderConfirmation()
      case 3:
        return <NeoOTP otp={otp} setOTP={setOtp} onSubmit={blockDebitCardRequest} loading={loading} />
      case 4:
        return <NeoSuccess message={message} linkPath='/requests' />
      default:
        return renderForm()
    }
  }

  const getCards = useCallback(async () => {
    try {
      setLoadingCards(true)
      const response = await RequestService.getCardList({ accountNumber: currentAccountDetail.accountNo })
      setCards(response)
      setLoadingCards(false)
      if (response.length === 0) {
        setMessage('No Cards found attached to the account')
        showModal()
      }
    } catch (error) {
      setMessage(error)
      setLoadingCards(false)
    }
  }, [showModal])

  useEffect(() => {
      getCards()
  }, [])

  const submitBlockDebitCardForm = useCallback(async (data, { setSubmitting }) => {
    try {
      setLoading(true)
      setSubmitting(true)
      setFormValues(data)
      let reqParams = {
        srcAccount: currentAccountDetail.accountNo,
        srcAccBranch: currentAccountDetail.brnCode,
        cardNo: data.cardNumber,
        remarks: data.remarks,
      }
      const response = await RequestService.blockDebitCardVerify(reqParams)
      if (response.status === 200) {
        setSubmitting(false)
        setOtpEnabled(response.data['otpEnable'])
        setLoading(false)
        setStage(2)
      }
    } catch (err) {
      setLoading(false)
    }
  }, [])

  const blockDebitCardRequest = useCallback(async () => {
    setLoading(true)
    try {
      let reqParams = {
        srcAccount: currentAccountDetail.accountNo,
        srcAccBranch: currentAccountDetail.brnCode,
        cardNo: formValues.cardNumber,
        otp,
        remarks: formValues.remarks,
      }
      const response = await RequestService.blockDebitCardConfirm(reqParams)
      setMessage(response.data['message'])
      setStage(4)
      setLoading(false)
    } catch (err) {
      setOtp('')
      setLoading(false)
    }
  }, [formValues, otp])

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function renderForm() {
    return (
      <div>
        <div className='heading-style'>Block Debit Card Request</div>
        <AccountDisplay currentAccountDetail={currentAccountDetail} />
        <Formik
          initialValues={{
            cardNumber: '',
            remarks: '',
          }}
          validationSchema={BlockDebitCardSchema}
          onSubmit={submitBlockDebitCardForm}>
          {({ isSubmitting, handleChange, errors, touched }) => (
            <Form>
              {/* <div className='form-group my-4'>
                <NeoInput
                  mode='select'
                  text='Account Number'
                  name='accountNumber'
                  onChange={(text) => {
                    handleChange(text)
                    setSelectedAccount(text.target.value)
                  }}
                  list={accounts}
                  keyValue='accountNo'
                />
                {loadingCards ? <NeoLoader /> : null}
                <InputError text={errors.accountNumber} touched={touched.accountNumber} />
              </div> */}
              <div className='form-group'>
                <NeoInput
                  mode='select'
                  text='Card Number'
                  name='cardNumber'
                  disabled={loadingCards}
                  onChange={handleChange}
                  list={cards}
                  keyValue='cardNo'
                />
                <InputError text={errors.cardNumber} touched={touched.cardNumber} />
              </div>
              <div className='form-group'>
                <NeoInput
                  text='Remarks'
                  disabled={loadingCards}
                  onChange={handleChange}
                  list={cards}
                  name='remarks'
                />
                <InputError text={errors.remarks} touched={touched.remarks} />
              </div>
              <div className='mt-5'>
                {isSubmitting ? (
                  renderLoading()
                ) : (
                  <NeoButton
                    mode='newDesign'
                    type='submit'
                    disabled={isSubmitting || loadingCards}
                    text='Submit'
                  />
                )}
              </div>

              <div className='back-cancel-style' onClick={() => history.goBack()}>
                {' '}
                Cancel{' '}
              </div>
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  function renderConfirmation() {
    return (
      <div className='d-flex flex-column confirmation'>
        <h3> Confirm Block Debit Card Request</h3>
        <AccountDisplay currentAccountDetail={currentAccountDetail} />

        <div>
          <h6 className='label'>Card Number</h6>
          <h6 className='value'>{formValues.cardNumber}</h6>
        </div>
        <div>
          <h6 className='label'>Remarks</h6>
          <h6 className='value'>{formValues.remarks}</h6>
        </div>
        <div className='mt-5'>
          {loading ? (
            renderLoading()
          ) : (
            <NeoButton
              mode={'newDesign'}
              type='button'
              className='btn btn-neo'
              text='Confirm'
              onClick={() => (otpEnabled ? setStage(3) : blockDebitCardRequest())}
            />
          )}
        </div>
        <div className='back-cancel-style' onClick={() => setStage(1)}>
          {' '}
          Back{' '}
        </div>
      </div>
    )
  }

  return (
    <LayoutWithAccountCard
      breadCumKey='DEBIT_CARD_BLOCK'
      showEmptySpace={true}
      keyPath={'DEBIT_CARD_BLOCK'}>
      {featureDetails[currentAccountDetail['accountType']] !== 'N' && (
        <div className='new-design-form-style'>{renderSwitch()}</div>
      )}

      {featureDetails[currentAccountDetail['accountType']] === 'N' && (
        <div className='no-data-found'>{t(VALIDATION_MESSAGES.NO_ACCESS)}</div>
      )}
    </LayoutWithAccountCard>
  )
}

export default BlockDebitCard
